import { StatusOption } from '../../hooks/useStatusOptions';
import { Assignee, AssigneeType } from '../../sdk';

const getAssigneeFromTransition = (
  assignedTo: Assignee[] | undefined | null | string,
  selectedTransition?: StatusOption,
) => {
  if (!selectedTransition || !assignedTo) {
    return [];
  }

  const assignees =
    typeof assignedTo === 'string' ? [{ id: assignedTo, type: AssigneeType.User }] : assignedTo;

  return assignees.filter(({ id }) => id in selectedTransition.assigneeUsers);
};

export default getAssigneeFromTransition;
